import type { Server } from '@forest/paywall-core'
import ky from 'ky'
import {
  event_rule_description,
  event_rule_prize_title,
  event_rule_title,
  focus_pass_page_subtitle,
  focus_pass_page_title,
} from './paraglide/messages'

const messageRegistry = {
  event_rule_description,
  event_rule_prize_title,
  event_rule_title,
  focus_pass_page_subtitle,
  focus_pass_page_title,
}

export interface JumpPointConfig {
  /**
   * Service-API product id per server; a missing key hides the point on
   * that server.
   */
  product_id: Partial<Record<Server, number>>
  required_score: number
  /** Display/pre-check only — the server owns actual pricing. */
  gem_price: number
}

export interface Config {
  title_key: string
  subtitle_key: string
  rules_key: string
  background: string
  main_visual_rive_url: string
  final_rewards_rive_url: string
  final_reward_footer_background: [string, string]
  free_final_reward_background: [string, string]
  paid_final_reward_background: [string, string]
  paid_reward_frame_color: [string, string]
  paid_reward_background: string
  iap_plus_sku_img: string
  paid_reward_flow_background: string
  free_reward_flow_background: string
  activity_id: number
  required_app_version: string
  /** Jump catch-up points; absent or empty disables the feature entirely. */
  jump_points?: JumpPointConfig[]
}

const CONFIG_URL =
  import.meta.env.MODE === 'production'
    ? 'https://forest-ops-web-campaign-configs.seekrtech.com/pass-event-config.json'
    : import.meta.env.MODE === 'dev'
      ? `https://pub-8f4e138a89ff46e792760551ca2a44f8.r2.dev/pass-event-config.json?ts=${Date.now()}`
      : `https://forest-ops-web-campaign-configs-staging.seekrtech.com/pass-event-config.json?ts=${Date.now()}`

export async function fetchConfig(): Promise<Config> {
  const data = await ky(CONFIG_URL).json<Config>()
  return data
}

export function getMessage(key: string): string {
  const fn = messageRegistry[key as keyof typeof messageRegistry]
  if (typeof fn === 'function') {
    return fn()
  }
  return key
}
